import React, { ReactNode, useEffect, useState } from 'react'
import { Paper, Typography, Box, Collapse, SxProps, Theme } from '@mui/material'
import {
  KeyboardArrowUp as ArrowUp,
  KeyboardArrowDown as ArrowDown,
} from '@mui/icons-material'
import { StyledPaperStyle } from './styled'

export const CommonCollapse = ({
  title,
  isCollapseOpen = true,
  hideCollapse = false,
  children,
  id,
  style,
  headerStyle,
  onToggleCollapse,
}) => {
  const [collapsed, setCollapsed] = useState(false)

  useEffect(() => {
    setCollapsed(!!isCollapseOpen)
  }, [isCollapseOpen])

  const handleToggleCollapse = () => {
    if (hideCollapse) return
    const newVal = !collapsed
    setCollapsed(newVal)
    onToggleCollapse?.(newVal)
  }

  return (
    <Paper sx={{ ...StyledPaperStyle, ...(style || {}) }} id={id}>
      <Box
        display={'flex'}
        justifyContent={'space-between'}
        alignItems={'center'}
        onClick={handleToggleCollapse}
        sx={{ ...(headerStyle || {}) }}
      >
        {typeof title === 'string' ? (
          <Typography variant='subtitle1'>{title}</Typography>
        ) : (
          <>{title}</>
        )}
        {hideCollapse ? (
          ''
        ) : collapsed ? (
          <ArrowUp color='action' />
        ) : (
          <ArrowDown color='action' />
        )}
      </Box>
      <Collapse in={collapsed}>
        <div style={{ marginTop: '20px' }}>{children}</div>
      </Collapse>
    </Paper>
  )
}

export default CommonCollapse
